import React from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import LocationCard from '../components/LocationCard';
import CemeteryMap from '../components/CemeteryMap';
import GpsMap from '../components/GpsMap';

export default function Result() {
  const location = useLocation();
  const navigate = useNavigate();
  const { person } = location.state || {};

  if (!person) {
    return <Navigate to="/" replace />;
  }

  const lat = parseFloat(person.latitude);
  const lng = parseFloat(person.longitude);
  const hasGps = Number.isFinite(lat) && Number.isFinite(lng);

  const marker = {
    x: parseFloat(person.x_position),
    y: parseFloat(person.y_position),
    block: person.block,
    sector: person.sector,
    number: person.number,
  };

  return (
    <div className="results-page">
      <div className="container">
        <div className="success-banner">
          <h2>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            Jazigo localizado!
          </h2>
          <p>Abaixo você pode visualizar a localização no mapa do cemitério.</p>
        </div>

        <div className="map-layout">
          <LocationCard
            person={person}
            onNewSearch={() => navigate('/')}
            onComoChegar={() => navigate('/como-chegar', { state: { person } })}
          />
          {hasGps ? (
            <GpsMap person={person} lat={lat} lng={lng} />
          ) : (
            <CemeteryMap marker={marker} />
          )}
        </div>
      </div>
    </div>
  );
}
